  <template>
  <b-modal style="padding:15px" size="lg" id="AssignRightsModal" ref="modal" title="Assign Rights" ok-title="Submit" cancel-title="Close" 
      @show= "showModal()" @hidden= "resetModal()" @ok= "handleOk" :ok-disabled = "this.$refs.AssignRightsForm != undefined ? !this.$refs.AssignRightsForm.checkValidity() : true">
        <form ref="AssignRightsForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
            <div class="col-md-3"></div>
            <div class="col-md-6">
              <!--NAME INPUT-->
              <b-form-group label="Select Menu" label-for="menu-input" autocomplete="off">
                
                 <b-form-select v-model= "selectedMenuId" :options="menuHeadings" value-field="id" text-field="name"  @change="getSelectedMenuRights()">
                   <b-form-select-option :value = "null" disabled hidden>All</b-form-select-option>
                 </b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-3" style="margin:auto;padding-top:12px;">
              <span @click="clearMenuFilter()">
                <i role = "button" title="clear filter" style="color:grey;" class="fas fa-times"></i>
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-8">
               <b-form-group label="Assigned Rights:">
                <b-form-checkbox-group id="checkbox-group-1" value-field="rightId" text-field="rightName"
                 v-model= "checkedRights" :options= "menuRights" name="menuRights"></b-form-checkbox-group>
              </b-form-group>
            </div>  
            <div class="col-md-2"></div> 
          </div>  
        </form>
      </b-modal>
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js';

export default {
    name: 'AddCompany',
    data(){
        return{
          moduleName:'Companies',
          menuHeadings:[],
          menuRights:[],
          selectedMenuId:null,
          checkedRights:[],
          unCheckedRights:[]
		}
  },
 
  props:{
        companyId:{
          type:Number,
          default:0
        }
   
  },
   watch: {
      checkedRights(newVal, oldVal) {
        if(newVal.length > oldVal.length)
        {
          var unMatchedArray = newVal.filter(value=>oldVal.indexOf(value) == -1);
          let id  = unMatchedArray.pop();
          let index = this.unCheckedRights.findIndex(x=>x == id)
          if(index > -1)
          {
            this.unCheckedRights.splice(index, 1);  
          }
        }
        else if(newVal.length < oldVal.length)
        {
          var unMatchedArr = oldVal.filter(value=>newVal.indexOf(value) == -1);
          let removedItemId  = unMatchedArr.pop();
          this.unCheckedRights.push(removedItemId);
          // let itemIndex = this.unCheckedRights.findIndex(x=>x == removedItemId)
        }
      
      }
  },
methods:{
  assignRights()
  {
    axios.post('/company/AssignRights', 
      {"CompanyId":this.companyId,"RightIds":this.checkedRights})
      .then(res=>{
            if(res.data.status == 1)
            {
               this.$bvModal.msgBoxOk('Rights assigned successfully!', {
                title: 'Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
                 this.$router.go()
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
  },
  clearMenuFilter()
  {
    this.selectedMenuId = "null"
    this.getAllMenus();
  },
  generateAssignedRights(menulist)
  {
    menulist.forEach(element => {
     
      let item = this.checkedRights.find(x=>x.rightId == element.rightId)
      if(item == undefined)
      {
        let item2 = this.unCheckedRights.find(x=>x.rightId == element.rightId)
        if(item2 == undefined)
        {
          if(element.isAssigned)
          {
            
            this.checkedRights.push(element.rightId);
          }
        }
      }

    });
  },
    getAllMenus()
  {
   
    axios.post('/company/GetRights', 
      {"CompanyId":this.companyId})
      .then(res=>{
            if(res.data.status == 1)
            {
              
               this.menuHeadings = res.data.data.headings;
               this.menuRights = res.data.data.rights;
              this.generateAssignedRights(this.menuRights);
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
  },

  getSelectedMenuRights()
  {
   
      axios.post('/company/GetMenuRights', 
      {"CompanyId":this.companyId, "HeadingId":this.selectedMenuId})
      .then(res=>{
            if(res.data.status == 1)
            {
                this.menuRights = res.data.data.rights;
                this.generateAssignedRights(this.menuRights);
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
  },

   checkFormValidity() {
        const valid = this.$refs.AssignRightsForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
      resetModal() {
        this.CompanyName='';
        this.Address = '';
        this.PhoneNumber = '';
       
      },
      showModal()
      {
        this.resetModal();
        
        this.getAllMenus();
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.assignRights()
        
        this.$nextTick(() => {
          //this.$router.go('/phones')
          this.$bvModal.hide('AssignRightsModal') 
        })
      },
 
  
  },
	

}
</script>
